import { useEffect } from 'react';

interface UseYooKassaPaymentWithEmailEffectsParams {
  shouldRedirect: boolean;
  confirmationUrl: string | null;
}

export const useYooKassaPaymentWithEmailEffects = ({
  shouldRedirect,
  confirmationUrl,
}: UseYooKassaPaymentWithEmailEffectsParams) => {
  useEffect(() => {
    if (!shouldRedirect || !confirmationUrl) return;

    // Страницу открывают по ссылке с телефона, где новая вкладка через
    // window.open блокируется браузером, поэтому уходим в ЮKassa текущей.
    window.location.assign(confirmationUrl);
  }, [shouldRedirect, confirmationUrl]);
};
